import { persist } from 'zustand/middleware';
import { useState, useEffect } from 'react';
import { create } from 'zustand';
import { getIsDemoDataCookie, setIsDemoDataCookie } from '@/server/cookies';
import { getCurrentlRequestUrl } from '@/server/get';
import { isUrlDev } from '@frontend/utils/tenant';

type AppOptions = {
	isDemo: boolean;
	_hasHydrated: boolean;
	setIsDemo: (is: boolean) => void;
	setHasHydrated: (has: boolean) => void;
};
export const appStore = create<AppOptions>()(
	persist<AppOptions>(
		(set) => ({
			isDemo: false,
			_hasHydrated: false,
			async setIsDemo(is) {
				set({ isDemo: is });
			},
			setHasHydrated(has) {
				set({ _hasHydrated: has });
			},
		}),
		{
			name: 'options',
			onRehydrateStorage: (state) => {
				return async () => {
					const isDemo = await getIsDemoDataCookie();
					const url = await getCurrentlRequestUrl();

					// Prod Check
					const isProd = !import.meta.env.DEV && !isUrlDev(url);

					if ((state.isDemo || isDemo) && isProd) {
						await setIsDemoDataCookie({ data: { is: false } });
						state.setIsDemo(false);
					} else if (state.isDemo !== isDemo) state.setIsDemo(isDemo);

					state.setHasHydrated(true);
				};
			},
		},
	),
);

export const useStore = <T, F>(
	store: (callback: (state: T) => unknown) => unknown,
	callback: (state: T) => F,
) => {
	const result = store(callback) as F;
	const [data, setData] = useState<F>();

	useEffect(() => {
		setData(result);
	}, [result]);

	return data;
};
